import { appURL as appURLGetter } from '@/store/modules/main/getters';
import { useStore } from '@/utils/store';

export const useMainGetters = () => {
	const { getter } = useStore();
	return { appURL: getter<string>(appURLGetter) };
};
